<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Type Input"  entityName="approvaltype" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card header="Approval Type Data" class="mb-3 card-max-width">
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="12" label="Name" label-for="input-name" size="sm" :model.sync="model.name"   />
				<app-input-textarea id="fieldset-description" label-cols-sm="12" label="Description" label-for="input-description" size="sm" :model.sync="model.description"   />
				<app-input-textbox id="fieldset-interface-name" label-cols-sm="12" label="Interface Name" label-for="input-interface-name" size="sm" :model.sync="model.interfaceName"   />
			</b-col>
		</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :model="model" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeList from '@/models/ApprovalType/ApprovalTypeList';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputTextarea,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterApprovalType : null,
			currentApprovalTypePage : 1,
			approvalTypePageSize: 10,
			sortByApprovalType: '',
			sortDescApprovalType: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalType : async function(id) {
			this.isBusy = true;
			ApprovalType.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalType = true;
			this.filterApprovalType.id = this.modelId;
			ApprovalType.downloadDataDetail(this, this.filterApprovalType).then(result => {
				this.isDownloadApprovalType = false;
			}).catch(error => { this.isDownloadApprovalType = false; })
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalType.updateData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvaltypeindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalType.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvaltypeindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		onHidden() {
			this.getApprovalTypes();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterApprovalType = new ApprovalTypeFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalType(id);
			} else {
				this.modelId = id;
				this.getApprovalType(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
	},
	beforeDestroy() {
	},
}
</script>
